<template>
  <div v-if="value" v-bsl="value"></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';

import TeacherSvg from '@/assets/images/onboarding/classlist.svg';
import ArrowTopImg from '@/assets/images/onboarding/arrowtop.svg';

export default {
  name: 'ClassListDesktop',
  props: {
    value: {
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),

    teacherImage() {
      return TeacherSvg;
    },

    arrowTopImage() {
      return ArrowTopImg;
    },

    onboardingStepText() {
      return `
        <div class="flex flex-col justify-center items-center">
          <img style="max-width: 155px" src="${this.teacherImage}"/>
          <h3 class="text-center">${this.$t('onboarding.homeworks_step1.title')}</h3>
          <p class="text-center py-4 px-6">${this.$t('onboarding.homeworks_step1.content')}</p>
          <p class="text-center pb-4 px-6">
            <span>${this.$t('onboarding.homeworks_step1.content2')}</span><span class="text-black">"</span><span class="font-bold">${this.$t('onboarding.homeworks_step1.content3')}</span><span class="text-black">"</span><span>${this.$t('onboarding.homeworks_step1.content4')}</span>
          </p>
        </div>`;
    },
  },
  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    addArrow(tour, direction) {
      const currentStepElement = tour.currentStep.el;
      const header = currentStepElement.querySelector('.shepherd-header');
      const progress = document.createElement('img');
      if (direction === 'top') {
        progress.classList.add('stepherd-custom-arrow--top');
        progress.src = `${this.arrowTopImage}`;
      }
      header.insertBefore(
        progress,
        currentStepElement.querySelector('.shepherd-cancel-icon'),
      );
    },

    startOnboarding() {
      this.$nextTick(() => {
        const vm = this;
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        });

        tour.addStep({
          text: vm.onboardingStepText,
          beforeShowPromise() {
            return new Promise((resolve) => {
              setTimeout(() => {
                window.scrollTo(0, 0);
                resolve();
              }, 500);
            });
          },
          attachTo: {
            element: '.classList',
            on: 'top-end',
          },
          modalOverlayOpeningRadius: 18,
          popperOptions: {
            placement: 'top-end',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 36],
                },
              },
            ],
          },
          buttons: [
            {
              text: this.$t('onboarding.grades.btn'),
              action() {
                vm.$emit('input', !vm.value);
                vm.acceptOnboardingTag();
                return this.cancel();
              },
            },
          ],
          when: {
            show() {
              vm.addArrow(this.tour, 'top');
            },
            cancel() {
              vm.$emit('input', !vm.value);
              vm.closeOnboardingTag();
            },
          },
        });

        tour.start();

        Event.$on('cancelTour', () => {
          tour.cancel();
        });
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>
